/// <amd-module name="SuiteCommerce.Blog.TaxonomyNavigation.Configuration"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.TaxonomyNavigation.Configuration", ["require", "exports", "SuiteCommerce.Blog.Common.Configuration"], function (require, exports, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var TaxonomyNavigationConfiguration = /** @class */ (function (_super) {
        __extends(TaxonomyNavigationConfiguration, _super);
        function TaxonomyNavigationConfiguration() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(TaxonomyNavigationConfiguration, "taxonomyNavigationTitle", {
            get: function () {
                return this.get('blog.taxonomyNavigationTitle');
            },
            enumerable: true,
            configurable: true
        });
        return TaxonomyNavigationConfiguration;
    }(Configuration_1.Configuration));
    exports.TaxonomyNavigationConfiguration = TaxonomyNavigationConfiguration;
});
